/**
 * Determines if client-side routing is needed based on the browser URL and
 * the Next.js page pathname. Strips query strings and hash fragments from
 * the browser path before comparison.
 *
 * @param asPath - The browser's current URL path (may include query string or hash)
 * @param pathname - The Next.js router pathname (the page file path)
 * @returns true if client-side routing is needed (paths differ), false otherwise
 */
export const shouldRouteClientSide = (
  asPath: string,
  pathname: string,
): boolean => {
  const browserPath = asPath.split(/[?#]/)[0];
  return browserPath !== pathname;
};
